import { memo } from "react";

function SuitabilityProgressBar({ total, completed }: { total: number; completed: number }) {
  return (
    <div className="w-full flex items-center gap-2.5 mt-2">
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={`h-0.5 xs:h-1 flex-1 rounded-full transition-all duration-300 ${i < completed ? "bg-white" : "bg-white/30"}`}
        />
      ))}
    </div>
  );
}

export default memo(SuitabilityProgressBar);
